import type { Theme } from '@mui/material/styles';
import { OPS_SHELL_Z } from '../../consultoria/constants';

/**
 * Camada dos menus e painéis abertos pela barra superior (conta, notificações, busca,
 * menu da aba): acima do Otto acoplado, senão abrem por trás dele.
 */
export const CHROME_OVERLAY_Z = OPS_SHELL_Z + 10;

/**
 * Cores do "chrome" (sidebar + barra superior). O conteúdo usa `background.default`
 * como folha; a separação é só por tom, sem bordas.
 */
export const getNavTokens = (theme: Theme) => {
  const dark = theme.palette.mode === 'dark';
  return {
    chrome: dark ? '#171717' : '#FFFFFF',
    canvas: theme.palette.background.default,
    ink: dark ? '#ECECEC' : '#0B1220',
    muted: dark ? '#A3A3A3' : '#5F6672',
    icon: dark ? '#D4D4D4' : '#374151',
    hover: dark ? 'rgba(255,255,255,0.06)' : 'rgba(15,23,42,0.055)',
    active: dark ? 'rgba(255,255,255,0.10)' : 'rgba(30,76,125,0.10)',
    accent: dark ? '#8DB9E2' : '#1E4C7D',
    brand: dark ? '#2C5688' : '#041121',
    focus: dark ? '#8DB9E2' : '#3A6CA8',
  };
};

export type NavTokens = ReturnType<typeof getNavTokens>;

/** Anel de foco por teclado compartilhado pelos controles do chrome. */
export const navFocusRing = (t: NavTokens) => ({
  '&.Mui-focusVisible, &:focus-visible': {
    outline: `2px solid ${t.focus}`,
    outlineOffset: 2,
  },
});
